export enum WorkflowConfigurationStage {
    AUTO_APPROVE_SERVICE_REQUEST = 'AUTO_APPROVE_SERVICE_REQUEST',
    AUTO_APPROVE_QUOTATION = 'AUTO_APPROVE_QUOTATION',
}

export enum AutoQuotationValidation {
    ALWAYS = 'ALWAYS',
    WITH_CREDIT_THRESHOLD = 'WITH_CREDIT_THRESHOLD',
}
